module.exports = "/static/fonts/SimplerPro_V3-Regular.a50962c.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SimplerPro_V3-Regular.otf
// module id = w5dP
// module chunks = 6